import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-id-search',
  templateUrl: './id-search.component.html',
  styleUrls: ['./id-search.component.scss'],
})
export class IdSearchComponent {
  @Input() addressLabel: string;
  @Input() config: any;
  @Input() requestType: any;
  @Input() disabled: boolean = false;
  @Output() placeSelected = new EventEmitter<any>();
  @Output() placeRemoved = new EventEmitter<any>();
  @ViewChild('searchTextField', { static: false }) searchTextField: any;
  showSearchIcon: boolean = false;
  private env = environment;

  get inputLabel() {
    return this.addressLabel ? this.addressLabel : '';
  }

  get placeholder() {
    if (this.requestType && this.requestType === 'id_bts_noa' && this.config.bts.types?.NOA) {
      return this.config.bts.types.NOA.placeholder;
    } else if (this.requestType && this.requestType === 'id_bts_building' && this.config.bts.types?.BUILDING && this.env.controls.agf) {
      return this.config.bts.types.BUILDING.placeholder;
    } else if (this.config.research_methods.id_building) {
      return this.config.building.placeholder;
    } else if (this.config.research_methods.id_school) {
      return this.config.school.placeholder;
    } else if (this.config.research_methods.id_healthcare) {
      return this.config.healthcare.placeholder;
    } else {
      return 'Search ID';
    }
  }

  onChangeContent(event) {
    if (event && event.inputType) {
      if (event.inputType == 'insertFromPaste' || event.inputType == 'insertText') {
        if (event.inputType == 'deleteContentBackward' || event.inputType == 'deleteContentForward' || event.inputType == 'deleteByCut') {
          this.reset(false);
        }
        this.showSearchIcon = true;
      } else {
        this.showSearchIcon = false;
      }
    }
    if (event && event.inputType) {
      if (event.inputType == 'deleteContentBackward' || event.inputType == 'deleteByCut' || event.inputType == 'deleteContentForward') {
        this.showSearchIcon = true;
      }
    }
  }

  reset(textNull) {
    if (textNull && this.searchTextField) {
      this.searchTextField.nativeElement.value = null;
      
    }
    this.showSearchIcon = true;
    this.placeRemoved.emit();
  }

  selectPlace(): void {
    const place = this.searchTextField.nativeElement.value.trim();
    if (place) {
      this.showSearchIcon = false;
      this.placeSelected.emit(place);
    }
  }
}
